import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import Form from "../Form/Form";

import Holidays from "../Modal/Holidays/Holidays";
import Subscriptions from "../Modal/Subscriptions/Subscriptions";

const defaults = {
    holidays: [
        {date: null, name: null},
        {date: null, name: null},
        {date: null, name: null}
    ]
}

@connect(store => {
    return {
        projectSettings: store.projectSettings
    };
})

class Calendar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCalendar: {}
        }
    }

    shouldComponentUpdate(nextProps){ 
        if(!_.isEqual(nextProps.scrollId, this.props.scrollId) && nextProps.scrollId) {
            if(this.refs[nextProps.scrollId]) {
                setTimeout(() => {
                    this.refs[nextProps.scrollId].scrollIntoView() 
                }, 100);
            }
        }
        return true
    }

    render() {
        const { projectSettings, view=false } = this.props;
        const defaultCalendarName = ((projectSettings.calendars.default || {}).calendars || {}).calendar;
        const defaultCalendarHolidays = (((projectSettings.calendars.default || {}).calendars || {}).calendar_holiday || []);

        const getTotalHolidays = () => {
            let totalHolidays = [...defaultCalendarHolidays.map(e=>moment(e.date).format('MM/DD/YYYY')), ...projectSettings.holidays.filter(h => h.date && h.holiday).map(e=>moment(e.date).format('MM/DD/YYYY'))];

            for(const selected of projectSettings.calendars.others) {
                totalHolidays = [...totalHolidays, ...selected.calendar_holiday.map(e=>moment(e.date).format('MM/DD/YYYY'))]
            }
            return _.uniq(totalHolidays).length;
        }

        const handleViewHolidays = (selected) => {
            this.setState({...this.state, selectedCalendar: selected}, () => {
                $("#holidaysViewModal").modal("show");
            });
        }

        const handleViewSubscriptions = () => {
            $("#subscriptionsViewModal").modal("show");
        }

        const workDays = Object.keys(_.omit(projectSettings.workingDays,'id', 'adjustedSetting','dateAdded', 'dateUpdated')).filter(d=>{
            return projectSettings.workingDays[d] === 1
        })
        const label = workDays.map(w=>{
           return w[0].toUpperCase() + w.substring(1)
        }).join(", ")
        const adjusted = projectSettings.workingDays.adjustedSetting
        return (
            <div class="settingsCalendar">
                <div class="pageHeader">Calendar</div>
                <div class="pageContainer">
                    <div class="calendarContainer">
                        <div class="calendarSection">
                            <div class="calendarDetails top">
                                <div class="detailItem">
                                    <label>Default Calendar</label>
                                    {defaultCalendarHolidays.length > 0 && <p>{defaultCalendarName} - <a onClick={() => handleViewHolidays(projectSettings.calendars.default.calendars)}>{defaultCalendarHolidays.length} Holiday/s</a></p>}
                                    {defaultCalendarHolidays.length === 0 && <p>{defaultCalendarName} - <span>{defaultCalendarHolidays.length} Holiday/s</span></p>}
                                </div>
                                <div class="detailItem">
                                    <label>Calendar Subscriptions</label>
                                    <p><a onClick={handleViewSubscriptions}>View</a></p>
                                </div>
                            </div>
                            <div class="calendarForm">
                                <Form holidays={projectSettings.holidays} view={view}/>
                            </div>
                            <div class="calendarDetails bottom bb">
                                <div class="detailItem">
                                    <label>Total Holiday/s: {getTotalHolidays()}</label>
                                </div>
                            </div>
                        </div>
                      
                             <div class="calendarSection">
                             <strong> Working Days: </strong>
                             <span class="ml30">{label}</span>
                             </div>
                             <div class="calendarSection mt20">
                                <strong> Adjusted Dates: </strong>
                                    <span class="ml20">
                                    
                                        {adjusted==='before' && <span>Automatically move due dates <strong>before</strong> holiday/s and non-working day/s (Recommended)</span>}
                                        {adjusted==='after' && <span>Automatically move due dates <strong>after</strong> holiday/s and non-working day/s</span>}
                                        {adjusted==='noChange' && <span>Don't move due dates</span>}
                                    
                                </span>
                             </div>
                    </div>
                </div>
                
                <Holidays calendar={this.state.selectedCalendar} />
                <Subscriptions calendars={projectSettings.list} selected={projectSettings.calendars.others} onView={handleViewHolidays} view={view}/>
            </div>
        );
    }
}

export default Calendar;